module.exports = __webpack_public_path__ + "static/media/SuccessOutlined.62623a70.svg";